import(/* webpackMode: "eager", webpackExports: ["AdminToolsButtonLazy"] */ "/vercel/path0/frontend/components/admin/admin-tools-button-lazy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Reveal"] */ "/vercel/path0/frontend/components/demo/reveal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/components/radial-gradient-background.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReportContentButton"] */ "/vercel/path0/frontend/components/report/report-content-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SmartBackButton"] */ "/vercel/path0/frontend/components/smart-back-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppShellProfileButton"] */ "/vercel/path0/frontend/components/top-menu/app-profile-button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/frontend/components/top-menu/language-selector/language-selector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RegionIndicatorBadge"] */ "/vercel/path0/frontend/components/top-menu/region-indicator-badge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchToggleClient"] */ "/vercel/path0/frontend/components/top-menu/search-toggle-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeSelector"] */ "/vercel/path0/frontend/components/top-menu/theme-selector/theme-selector-server.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_react-dom@18.3.1_react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_react-dom@18.3.1_react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_react-dom@18.3.1_react@18.3.1/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
